<template lang="pug">
  .row
    .col-md-8
      b-card.mb-2
        .container
          .row
            .col-9
              h4.mt-0 AWAY
              p(v-if="isAway") Your art is currently not being showcased, please remember to change your status to available once you are available for business.
              p(v-else="") Temporarily unvailable? Set your account to away mode.
            .col-3.d-flex.align-items-center.justify-content-center
              b-spinner(v-if="alert.loading", type="grow")
              b-form-checkbox(v-else="", v-model='isAway', switch, @change="toggleAway")
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import standardMix from '@/mixins/standardMix';
import { userService, apiService } from '@/services';

export default {
  components: {
  },
  mixins: [standardMix],
  data() {
    return {
      isAway: false,
      busyPersona: false,
    };
  },
  computed: {
  },
  methods: {
    ...mapActions('account', ['updateAccount', 'logout']),
    ...mapMutations('account', ['toggleArtistAway']),
    async toggleAway() {
      try {
        this.loading();
        await apiService.toggleAway(this.profileId);
        this.success('Account updated');
        this.isAway = !this.isAway;
        // this.toggleArtistAway();
      } catch (error) {
        // this.isAway = this.isAway;
        this.error('Could not toggle away mode');
      }
    },
  },
  async created() {
    try {
      this.loading();
      const artist = await userService.getProfile(this.profileId);
      this.isAway = artist.is_away;
      this.clear();
    } catch (error) {
      this.error('Could not find artist');
    }
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/views/AccountSettings.vue